// Auto-generated by backend/generate_ask_ui.py — Tanya Manasik (Jev routing) labels (11 languages).
export const ASK_UI = {
  "title": {
    "id": "Tanya Manasik",
    "en": "Ask Manasik",
    "ar": "اسأل عن المناسك",
    "fr": "Demander Manasik",
    "de": "Manasik fragen",
    "es": "Preguntar Manasik",
    "ru": "Спросить о манасик",
    "zh": "询问朝觐功课",
    "ja": "マナシクに質問する",
    "ko": "마나시크 질문하기",
    "hi": "मनासिक से पूछें"
  },
  "subtitle": {
    "id": "Ketik pertanyaan Anda — kami arahkan langsung ke panduan yang tepat.",
    "en": "Type your question — we will guide you directly to the right resource.",
    "ar": "اكتب سؤالك — سنرشدك مباشرةً إلى الدليل المناسب.",
    "fr": "Tapez votre question — nous vous orientons directement vers le bon guide.",
    "de": "Geben Sie Ihre Frage ein — wir leiten Sie direkt zur richtigen Anleitung weiter.",
    "es": "Escribe tu pregunta — te dirigimos directamente a la guía correcta.",
    "ru": "Введите ваш вопрос — мы направим вас прямо к нужному руководству.",
    "zh": "输入您的问题——我们将直接引导您找到正确的指南。",
    "ja": "質問を入力してください — 適切なガイドへ直接ご案内します。",
    "ko": "질문을 입력하세요 — 올바른 가이드로 바로 안내해 드립니다.",
    "hi": "अपना प्रश्न टाइप करें — हम आपको सीधे सही मार्गदर्शिका तक पहुँचाएंगे।"
  },
  "placeholder": {
    "id": "Contoh: Bolehkah memakai sabun wangi saat ihram?",
    "en": "Example: Is it permissible to use scented soap while in Ihram?",
    "ar": "مثال: هل يجوز استخدام الصابون المعطَّر في حالة الإحرام؟",
    "fr": "Exemple : Est-il permis d'utiliser du savon parfumé en état d'Ihram ?",
    "de": "Beispiel: Darf man beim Ihram parfümierte Seife verwenden?",
    "es": "Ejemplo: ¿Está permitido usar jabón perfumado durante el Ihram?",
    "ru": "Пример: Разрешено ли использовать ароматное мыло в состоянии Ихрама?",
    "zh": "示例：处于戒衣（Ihram）状态时可以使用香皂吗？",
    "ja": "例：イフラーム中に香り付き石鹸を使用することは許可されますか？",
    "ko": "예시: 이흐람 중에 향기 있는 비누를 사용해도 됩니까?",
    "hi": "उदाहरण: क्या इहराम की अवस्था में सुगंधित साबुन का उपयोग करना जायज़ है?"
  },
  "ask": {
    "id": "Tanya",
    "en": "Ask",
    "ar": "اسأل",
    "fr": "Demander",
    "de": "Fragen",
    "es": "Preguntar",
    "ru": "Спросить",
    "zh": "提问",
    "ja": "質問する",
    "ko": "질문하기",
    "hi": "पूछें"
  },
  "thinking": {
    "id": "Mencari jawaban…",
    "en": "Searching for an answer…",
    "ar": "جارٍ البحث عن الإجابة…",
    "fr": "Recherche d'une réponse…",
    "de": "Antwort wird gesucht…",
    "es": "Buscando una respuesta…",
    "ru": "Поиск ответа…",
    "zh": "正在搜索答案……",
    "ja": "回答を検索中…",
    "ko": "답변을 검색 중…",
    "hi": "उत्तर खोजा जा रहा है…"
  },
  "topicLabel": {
    "id": "Topik",
    "en": "Topic",
    "ar": "الموضوع",
    "fr": "Sujet",
    "de": "Thema",
    "es": "Tema",
    "ru": "Тема",
    "zh": "主题",
    "ja": "トピック",
    "ko": "주제",
    "hi": "विषय"
  },
  "openPage": {
    "id": "Buka",
    "en": "Open",
    "ar": "افتح",
    "fr": "Ouvrir",
    "de": "Öffnen",
    "es": "Abrir",
    "ru": "Открыть",
    "zh": "打开",
    "ja": "開く",
    "ko": "열기",
    "hi": "खोलें"
  },
  "relatedFaq": {
    "id": "Jawaban dari Tanya Jawab",
    "en": "Answers from Q&A",
    "ar": "إجابات من الأسئلة والأجوبة",
    "fr": "Réponses de la FAQ",
    "de": "Antworten aus dem FAQ",
    "es": "Respuestas de Preguntas y Respuestas",
    "ru": "Ответы из раздела вопросов и ответов",
    "zh": "来自问答的解答",
    "ja": "よくある質問からの回答",
    "ko": "질문과 답변에서의 답변",
    "hi": "प्रश्न-उत्तर से जवाब"
  },
  "noFaq": {
    "id": "Belum ada jawaban pasti di Tanya Jawab — lihat panduan terkait di bawah.",
    "en": "No definitive answer yet in Q&A — see related guides below.",
    "ar": "لا توجد إجابة محددة بعد في الأسئلة والأجوبة — راجع الأدلة ذات الصلة أدناه.",
    "fr": "Pas encore de réponse définitive dans la FAQ — consultez les guides connexes ci-dessous.",
    "de": "Noch keine eindeutige Antwort in den FAQ — siehe verwandte Anleitungen unten.",
    "es": "Aún no hay una respuesta definitiva en Preguntas y Respuestas — consulta las guías relacionadas a continuación.",
    "ru": "В разделе вопросов и ответов пока нет точного ответа — смотрите связанные руководства ниже.",
    "zh": "问答中暂无明确答案——请查看下方相关指南。",
    "ja": "Q&Aにはまだ明確な回答がありません — 以下の関連ガイドをご覧ください。",
    "ko": "질문과 답변에 아직 명확한 답변이 없습니다 — 아래 관련 가이드를 참조하세요.",
    "hi": "प्रश्न-उत्तर में अभी कोई निश्चित उत्तर नहीं है — नीचे संबंधित मार्गदर्शिकाएँ देखें।"
  },
  "busy": {
    "id": "Layanan sedang sibuk, coba lagi sebentar.",
    "en": "Service is currently busy, please try again shortly.",
    "ar": "الخدمة مشغولة حالياً، يرجى المحاولة مرة أخرى بعد قليل.",
    "fr": "Le service est actuellement occupé, veuillez réessayer dans un moment.",
    "de": "Der Dienst ist derzeit ausgelastet, bitte versuchen Sie es gleich erneut.",
    "es": "El servicio está ocupado en este momento, inténtelo de nuevo en breve.",
    "ru": "Сервис сейчас занят, пожалуйста, повторите попытку через некоторое время.",
    "zh": "服务当前繁忙，请稍后重试。",
    "ja": "サービスが混み合っています。しばらくしてから再試行してください。",
    "ko": "서비스가 현재 혼잡합니다. 잠시 후 다시 시도해 주세요.",
    "hi": "सेवा अभी व्यस्त है, कृपया थोड़ी देर बाद पुनः प्रयास करें।"
  },
  "failed": {
    "id": "Tidak dapat memproses pertanyaan. Silakan coba lagi.",
    "en": "Unable to process the question. Please try again.",
    "ar": "تعذّر معالجة السؤال. يرجى المحاولة مرة أخرى.",
    "fr": "Impossible de traiter la question. Veuillez réessayer.",
    "de": "Die Frage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
    "es": "No se pudo procesar la pregunta. Por favor, inténtelo de nuevo.",
    "ru": "Не удалось обработать вопрос. Пожалуйста, попробуйте ещё раз.",
    "zh": "无法处理该问题，请重试。",
    "ja": "質問を処理できませんでした。もう一度お試しください。",
    "ko": "질문을 처리할 수 없습니다. 다시 시도해 주세요.",
    "hi": "प्रश्न संसाधित करने में असमर्थ। कृपया पुनः प्रयास करें।"
  },
  "tooShort": {
    "id": "Tulis pertanyaan minimal 3 karakter.",
    "en": "Please enter a question of at least 3 characters.",
    "ar": "يرجى كتابة سؤال لا يقل عن 3 أحرف.",
    "fr": "Veuillez saisir une question d'au moins 3 caractères.",
    "de": "Bitte geben Sie eine Frage mit mindestens 3 Zeichen ein.",
    "es": "Por favor, escriba una pregunta de al menos 3 caracteres.",
    "ru": "Пожалуйста, введите вопрос длиной не менее 3 символов.",
    "zh": "请输入至少3个字符的问题。",
    "ja": "質問は3文字以上入力してください。",
    "ko": "질문을 최소 3자 이상 입력해 주세요.",
    "hi": "कृपया कम से कम 3 अक्षरों का प्रश्न लिखें।"
  },
  "examplesLabel": {
    "id": "Coba tanya:",
    "en": "Try asking:",
    "ar": "جرّب أن تسأل:",
    "fr": "Essayez de demander :",
    "de": "Versuche zu fragen:",
    "es": "Intenta preguntar:",
    "ru": "Попробуйте спросить:",
    "zh": "试着问：",
    "ja": "質問してみてください：",
    "ko": "질문해 보세요:",
    "hi": "पूछकर देखें:"
  },
  "example1": {
    "id": "Bolehkah memakai sabun wangi saat ihram?",
    "en": "Is it permissible to use scented soap during Ihram?",
    "ar": "هل يجوز استخدام الصابون المعطر في حالة الإحرام؟",
    "fr": "Est-il permis d'utiliser du savon parfumé pendant l'Ihram ?",
    "de": "Ist es erlaubt, parfümierte Seife während des Ihrams zu benutzen?",
    "es": "¿Está permitido usar jabón perfumado durante el Ihram?",
    "ru": "Допустимо ли использовать ароматное мыло в состоянии Ихрама?",
    "zh": "在戒衣（Ihram）状态下可以使用香皂吗？",
    "ja": "イフラーム中に香りつき石鹸を使用することは許されますか？",
    "ko": "이흐람 중에 향이 나는 비누를 사용해도 됩니까?",
    "hi": "क्या इहराम के दौरान सुगंधित साबुन का उपयोग करना जायज़ है?"
  },
  "example2": {
    "id": "Berapa putaran tawaf dan mulai dari mana?",
    "en": "How many circuits does Tawaf consist of, and where does it begin?",
    "ar": "كم عدد أشواط الطواف ومن أين يبدأ؟",
    "fr": "Combien de tours comprend le Tawaf et d'où commence-t-il ?",
    "de": "Aus wie vielen Runden besteht der Tawaf und wo beginnt er?",
    "es": "¿Cuántas vueltas tiene el Tawaf y desde dónde comienza?",
    "ru": "Из скольких кругов состоит Таваф и откуда он начинается?",
    "zh": "塔瓦夫（Tawaf）共绕行几圈，从哪里开始？",
    "ja": "タワーフは何周で、どこから始まりますか？",
    "ko": "타와프는 몇 바퀴이며 어디서 시작합니까?",
    "hi": "तवाफ में कितने चक्कर होते हैं और यह कहाँ से शुरू होता है?"
  },
  "example3": {
    "id": "Obat apa yang perlu dibawa ke Tanah Suci?",
    "en": "What medicines should be brought to the Holy Land?",
    "ar": "ما الأدوية التي ينبغي إحضارها إلى الأراضي المقدسة؟",
    "fr": "Quels médicaments faut-il apporter en Terre Sainte ?",
    "de": "Welche Medikamente sollte man mit ins Heilige Land nehmen?",
    "es": "¿Qué medicamentos se deben llevar a la Tierra Santa?",
    "ru": "Какие лекарства следует взять с собой на Святую землю?",
    "zh": "前往圣地需要携带哪些药品？",
    "ja": "聖地へ持参すべき薬は何ですか？",
    "ko": "성지에 가져가야 할 약은 무엇입니까?",
    "hi": "पवित्र भूमि पर कौन सी दवाइयाँ साथ ले जानी चाहिए?"
  },
  "poweredBy": {
    "id": "Klasifikasi cepat oleh Jev",
    "en": "Quick classification by Jev",
    "ar": "تصنيف سريع بواسطة Jev",
    "fr": "Classification rapide par Jev",
    "de": "Schnelle Klassifizierung durch Jev",
    "es": "Clasificación rápida por Jev",
    "ru": "Быстрая классификация от Jev",
    "zh": "由 Jev 快速分类",
    "ja": "Jev による迅速な分類",
    "ko": "Jev의 빠른 분류",
    "hi": "Jev द्वारा त्वरित वर्गीकरण"
  },
  "topic.ihram": {
    "id": "Ihram & Niat",
    "en": "Ihram & Intention",
    "ar": "الإحرام والنية",
    "fr": "Ihram & Intention",
    "de": "Ihram & Absicht",
    "es": "Ihram & Intención",
    "ru": "Ихрам и Намерение",
    "zh": "戒衣（Ihram）与意图",
    "ja": "イフラームとニーヤ（意図）",
    "ko": "이흐람 & 니야(의도)",
    "hi": "इहराम और नियत"
  },
  "topic.tawaf": {
    "id": "Tawaf",
    "en": "Tawaf",
    "ar": "الطواف",
    "fr": "Tawaf",
    "de": "Tawaf",
    "es": "Tawaf",
    "ru": "Таваф",
    "zh": "绕行（Tawaf）",
    "ja": "タワーフ（Tawaf）",
    "ko": "타와프（Tawaf）",
    "hi": "तवाफ़ (Tawaf)"
  },
  "topic.sai": {
    "id": "Sa'i",
    "en": "Sa'i",
    "ar": "السعي",
    "fr": "Sa'i",
    "de": "Sa'i",
    "es": "Sa'i",
    "ru": "Са'й",
    "zh": "奔走（Sa'i）",
    "ja": "サイー（Sa'i）",
    "ko": "사이（Sa'i）",
    "hi": "सई (Sa'i)"
  },
  "topic.tahallul": {
    "id": "Tahallul",
    "en": "Tahallul",
    "ar": "التحلل",
    "fr": "Tahallul",
    "de": "Tahallul",
    "es": "Tahallul",
    "ru": "Тахаллул",
    "zh": "解禁（Tahallul）",
    "ja": "タハッルル（Tahallul）",
    "ko": "타할룰（Tahallul）",
    "hi": "तहल्लुल (Tahallul)"
  },
  "topic.hajj_days": {
    "id": "Hari-hari Haji",
    "en": "Days of Hajj",
    "ar": "أيام الحج",
    "fr": "Les jours du Hajj",
    "de": "Die Tage der Hajj",
    "es": "Los días del Hajj",
    "ru": "Дни Хаджа",
    "zh": "朝觐日程（Hajj Days）",
    "ja": "ハッジの日々",
    "ko": "하지의 날들",
    "hi": "हज के दिन"
  },
  "topic.dua": {
    "id": "Doa & Zikir",
    "en": "Du'a & Dhikr",
    "ar": "الدعاء والذكر",
    "fr": "Du'a et Dhikr",
    "de": "Du'a & Dhikr",
    "es": "Du'a y Dhikr",
    "ru": "Дуа и Зикр",
    "zh": "祈祷与赞念（Du'a & Dhikr）",
    "ja": "ドゥアーとズィクル（Du'a & Dhikr）",
    "ko": "두아와 디크르（Du'a & Dhikr）",
    "hi": "दुआ और ज़िक्र (Du'a & Dhikr)"
  },
  "topic.prayer": {
    "id": "Salat & Kiblat",
    "en": "Salat & Qiblah",
    "ar": "الصلاة والقبلة",
    "fr": "Salat et Qibla",
    "de": "Salat & Qibla",
    "es": "Salat y Qibla",
    "ru": "Салят и Кибла",
    "zh": "礼拜与朝向（Salat & Qiblah）",
    "ja": "サラートとキブラ（Salat & Qiblah）",
    "ko": "살라트와 끼블라（Salat & Qiblah）",
    "hi": "सलात और क़िब्ला (Salat & Qiblah)"
  },
  "topic.ziyarah": {
    "id": "Ziarah & Masjid",
    "en": "Ziyarah & Mosques",
    "ar": "الزيارة والمساجد",
    "fr": "Ziyarah & Mosquées",
    "de": "Ziyarah & Moscheen",
    "es": "Ziyarah & Mezquitas",
    "ru": "Зиярат и мечети",
    "zh": "探访与清真寺",
    "ja": "ズィヤーラと清真寺",
    "ko": "지야라 & 모스크",
    "hi": "ज़ियारह और मस्जिदें"
  },
  "topic.health": {
    "id": "Kesehatan",
    "en": "Health",
    "ar": "الصحة",
    "fr": "Santé",
    "de": "Gesundheit",
    "es": "Salud",
    "ru": "Здоровье",
    "zh": "健康",
    "ja": "健康",
    "ko": "건강",
    "hi": "स्वास्थ्य"
  },
  "topic.logistics": {
    "id": "Dokumen & Persiapan",
    "en": "Documents & Preparation",
    "ar": "الوثائق والتحضير",
    "fr": "Documents & Préparation",
    "de": "Dokumente & Vorbereitung",
    "es": "Documentos & Preparación",
    "ru": "Документы и подготовка",
    "zh": "证件与准备",
    "ja": "書類と準備",
    "ko": "서류 및 준비",
    "hi": "दस्तावेज़ और तैयारी"
  },
  "topic.women": {
    "id": "Fikih Wanita",
    "en": "Women's Fiqh",
    "ar": "فقه المرأة",
    "fr": "Fiqh des Femmes",
    "de": "Frauen-Fiqh",
    "es": "Fiqh de la Mujer",
    "ru": "Фикх женщин",
    "zh": "女性教法",
    "ja": "女性のフィクフ",
    "ko": "여성 피끄흐",
    "hi": "महिलाओं का फ़िक़्ह"
  },
  "topic.other": {
    "id": "Umum",
    "en": "General",
    "ar": "عام",
    "fr": "Général",
    "de": "Allgemein",
    "es": "General",
    "ru": "Общее",
    "zh": "综合",
    "ja": "一般",
    "ko": "일반",
    "hi": "सामान्य"
  },
  "page.guide": {
    "id": "Panduan Manasik",
    "en": "Manasik Guide",
    "ar": "دليل المناسك",
    "fr": "Guide des Manasik",
    "de": "Manasik-Leitfaden",
    "es": "Guía de Manasik",
    "ru": "Руководство по манасику",
    "zh": "朝觐礼仪指南",
    "ja": "マナーシク・ガイド",
    "ko": "마나식 안내서",
    "hi": "मनासिक गाइड"
  },
  "page.hajjTimeline": {
    "id": "Kronologi Haji",
    "en": "Hajj Timeline",
    "ar": "الجدول الزمني للحج",
    "fr": "Chronologie du Hajj",
    "de": "Hajj-Zeitplan",
    "es": "Cronología del Hajj",
    "ru": "Хронология Хаджа",
    "zh": "朝觐时间轴",
    "ja": "ハッジのタイムライン",
    "ko": "하지 일정",
    "hi": "हज की समयरेखा"
  },
  "page.prayers": {
    "id": "Kumpulan Doa",
    "en": "Prayer Collection",
    "ar": "مجموعة الأدعية",
    "fr": "Recueil de Douas",
    "de": "Gebetssammlung",
    "es": "Colección de Súplicas",
    "ru": "Сборник Дуа",
    "zh": "祈祷文集",
    "ja": "ドゥアー集",
    "ko": "기도 모음",
    "hi": "दुआओं का संग्रह"
  },
  "page.zikir": {
    "id": "Zikir Utama",
    "en": "Essential Dhikr",
    "ar": "الأذكار الرئيسية",
    "fr": "Dhikr Essentiels",
    "de": "Wesentliche Dhikr",
    "es": "Dhikr Esenciales",
    "ru": "Основные Зикры",
    "zh": "核心迪克尔",
    "ja": "重要なズィクル",
    "ko": "핵심 디크르",
    "hi": "प्रमुख ज़िक्र"
  },
  "page.times": {
    "id": "Waktu Salat & Kiblat",
    "en": "Prayer Times & Qibla",
    "ar": "أوقات الصلاة والقبلة",
    "fr": "Horaires de Prière et Qibla",
    "de": "Gebetszeiten & Qibla",
    "es": "Horarios de Oración y Qibla",
    "ru": "Время Намаза и Кибла",
    "zh": "礼拜时间与朝向",
    "ja": "礼拝時間とキブラ",
    "ko": "예배 시간 및 키블라",
    "hi": "नमाज़ के वक्त और क़िबला"
  },
  "page.sunnah": {
    "id": "Salat Sunnah",
    "en": "Sunnah Prayer",
    "ar": "الصلاة السنة",
    "fr": "Prière Sunnah",
    "de": "Sunnah-Gebet",
    "es": "Oración Sunnah",
    "ru": "Сунна-Намаз",
    "zh": "逊奈礼拜",
    "ja": "スンナ礼拝",
    "ko": "순나 예배",
    "hi": "सुन्नत नमाज़"
  },
  "page.jenazah": {
    "id": "Salat Jenazah",
    "en": "Funeral Prayer",
    "ar": "صلاة الجنازة",
    "fr": "Prière Funèbre (Janāzah)",
    "de": "Totengebet (Janāzah)",
    "es": "Oración Fúnebre (Janāzah)",
    "ru": "Погребальная Молитва (Джаназа)",
    "zh": "殡礼（站礼拜）",
    "ja": "ジャナーザ礼拝",
    "ko": "장례 예배 (자나자)",
    "hi": "जनाज़ा की नमाज़"
  },
  "page.ziyarah": {
    "id": "Ziarah",
    "en": "Ziyarah",
    "ar": "زيارة",
    "fr": "Ziyarah",
    "de": "Ziyarah",
    "es": "Ziyarah",
    "ru": "Зиярат",
    "zh": "探访圣地（Ziyarah）",
    "ja": "ズィヤーラ（Ziyarah）",
    "ko": "지야라（Ziyarah）",
    "hi": "ज़ियारत (Ziyarah)"
  },
  "page.nabawi": {
    "id": "Masjid Nabawi",
    "en": "Masjid Nabawi",
    "ar": "المسجد النبوي",
    "fr": "Masjid Nabawi",
    "de": "Masjid Nabawi",
    "es": "Masjid Nabawi",
    "ru": "Мечеть Набави",
    "zh": "先知清真寺（Masjid Nabawi）",
    "ja": "マスジド・ナバウィ",
    "ko": "마스지드 나바위",
    "hi": "मस्जिद नबवी"
  },
  "page.baqi": {
    "id": "Pemakaman Baqi",
    "en": "Jannatul Baqi' Cemetery",
    "ar": "مقبرة جنة البقيع",
    "fr": "Cimetière de Jannatul Baqi'",
    "de": "Jannatul Baqi' Friedhof",
    "es": "Cementerio de Jannatul Baqi'",
    "ru": "Кладбище Джаннатул-Баки",
    "zh": "天堂墓园（Jannatul Baqi'）",
    "ja": "ジャンナトゥル・バキー墓地",
    "ko": "잔나툴 바끼 묘지",
    "hi": "जन्नतुल बक़ी कब्रिस्तान"
  },
  "page.haram": {
    "id": "Masjidil Haram",
    "en": "Masjidil Haram",
    "ar": "المسجد الحرام",
    "fr": "Masjidil Haram",
    "de": "Masjidil Haram",
    "es": "Masjidil Haram",
    "ru": "Масджидуль-Харам",
    "zh": "禁寺（Masjidil Haram）",
    "ja": "マスジドゥル・ハラーム",
    "ko": "마스지딜 하람",
    "hi": "मस्जिदुल हराम"
  },
  "page.health": {
    "id": "Tips Kesehatan",
    "en": "Health Tips",
    "ar": "نصائح صحية",
    "fr": "Conseils de Santé",
    "de": "Gesundheitstipps",
    "es": "Consejos de Salud",
    "ru": "Советы по здоровью",
    "zh": "健康小贴士",
    "ja": "健康のヒント",
    "ko": "건강 팁",
    "hi": "स्वास्थ्य सुझाव"
  },
  "page.sehat": {
    "id": "Sehat di Tanah Suci",
    "en": "Staying Healthy in the Holy Land",
    "ar": "الصحة في الأراضي المقدسة",
    "fr": "Rester en bonne santé en Terre Sainte",
    "de": "Gesund bleiben im Heiligen Land",
    "es": "Mantenerse Saludable en Tierra Santa",
    "ru": "Здоровье на Святой Земле",
    "zh": "在圣地保持健康",
    "ja": "聖地での健康管理",
    "ko": "성지에서 건강 유지하기",
    "hi": "पवित्र भूमि में स्वस्थ रहें"
  },
  "page.prep": {
    "id": "Persiapan Keberangkatan",
    "en": "Departure Preparation",
    "ar": "الاستعداد للسفر",
    "fr": "Préparation au Départ",
    "de": "Reisevorbereitung",
    "es": "Preparación para la Partida",
    "ru": "Подготовка к отъезду",
    "zh": "出发准备",
    "ja": "出発の準備",
    "ko": "출발 준비",
    "hi": "प्रस्थान की तैयारी"
  },
  "page.packages": {
    "id": "Paket Perjalanan",
    "en": "Travel Packages",
    "ar": "باقات السفر",
    "fr": "Forfaits de Voyage",
    "de": "Reisepakete",
    "es": "Paquetes de Viaje",
    "ru": "Туристические пакеты",
    "zh": "旅行套餐",
    "ja": "旅行パッケージ",
    "ko": "여행 패키지",
    "hi": "यात्रा पैकेज"
  },
  "page.faq": {
    "id": "Tanya Jawab",
    "en": "Frequently Asked Questions",
    "ar": "الأسئلة الشائعة",
    "fr": "Questions Fréquemment Posées",
    "de": "Häufig gestellte Fragen",
    "es": "Preguntas Frecuentes",
    "ru": "Часто задаваемые вопросы",
    "zh": "常见问题",
    "ja": "よくある質問",
    "ko": "자주 묻는 질문",
    "hi": "अक्सर पूछे जाने वाले प्रश्न"
  },
  "page.belajar": {
    "id": "Belajar Manasik",
    "en": "Learning Manasik",
    "ar": "تعلّم المناسك",
    "fr": "Apprendre les Manasik",
    "de": "Manasik Lernen",
    "es": "Aprender Manasik",
    "ru": "Изучение Манасик",
    "zh": "学习朝觐仪轨（Manasik）",
    "ja": "マナシク（Manasik）を学ぶ",
    "ko": "마나식(Manasik) 배우기",
    "hi": "मनासिक सीखें"
  }
};
